import { useCallback, useRef } from 'react';
import { useSubscription } from './useSubscription';
import { useLocalizedNavigate } from '@/components/i18n';
import { showMilestoneToast } from '@/components/upsell/MilestoneNudge';

/**
 * Hook that checks subscription tier and provides a function to trigger
 * milestone nudge toasts. Nudges are suppressed for premium/professional users.
 * Each milestone is shown only once per user (stored in localStorage).
 */
export function useMilestoneNudge() {
  const { tier } = useSubscription();
  const navigate = useLocalizedNavigate();
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;

  const triggerMilestone = useCallback(
    (milestoneId: string) => {
      // Only for free/core users
      if (tier === 'premium' || tier === 'professional') return;

      showMilestoneToast(milestoneId, navigateRef.current);
    },
    [tier],
  );

  return { triggerMilestone };
}
